@if(showBar) {
    <ul class="filter-bar">
        @for(filter of filter?.filters; track filter) {
            <li><app-filter [filter]="filter" (filterChange)="filterSelected($event)" [showProductType] = showProductType [showSport]="showSport"></app-filter> </li>
        }
    </ul>
}
